import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { NewsArticle } from './news-article.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class NewsArticleService extends AbstractEntityService {

    protected resourceUrl = 'api/news-articles';
    protected resourceSearchUrl = 'api/_search/news-articles';
    protected resourceCountUrl = 'api/_search/count/news-articles';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(newsArticle: NewsArticle): Observable<NewsArticle> {
        let copy: NewsArticle = Object.assign({}, newsArticle);
        copy.validSince = this.dateUtils.toDate(newsArticle.validSince);
        copy.validUntil = this.dateUtils.toDate(newsArticle.validUntil);
        return this.http.post<NewsArticle>(this.resourceUrl, copy).map((res: NewsArticle) => {
            return res;
        });
    }

    update(newsArticle: NewsArticle): Observable<NewsArticle> {
        let copy: NewsArticle = Object.assign({}, newsArticle);

        copy.validSince = this.dateUtils.toDate(newsArticle.validSince);

        copy.validUntil = this.dateUtils.toDate(newsArticle.validUntil);
        return this.http.put<NewsArticle>(this.resourceUrl, copy).map((res: NewsArticle) => {
            return res;
        });
    }

    find(id: number): Observable<NewsArticle> {
        return this.http.get<NewsArticle>(`${this.resourceUrl}/${id}`).map((res: NewsArticle) => {
            let jsonResponse = res;
            jsonResponse.validSince = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.validSince);
            jsonResponse.validUntil = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.validUntil);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<NewsArticle[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<NewsArticle[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<NewsArticle[]>) => this.convertResponse(res));
    }

    search(req?: any): Observable<HttpResponse<NewsArticle[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<NewsArticle[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<NewsArticle[]>) => this.convertResponse(res));
    }

    private convertResponse(res: HttpResponse<NewsArticle[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].validSince = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].validSince);
            jsonResponse[i].validUntil = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].validUntil);
        }
        return res.clone({body: jsonResponse});
    }

    /**
     * Load valid NewsArticles for the specified date, filtering by showInHomePage and showInLessonsPage flags.
     * If no date is received returns the valid news for the current date.
     */
    findValidByDate({dateSearch, showInHomePage, showInLessonsPage }:
        {dateSearch?: Date; showInHomePage?: boolean; showInLessonsPage?: boolean; }): Observable<HttpResponse<NewsArticle[]>> {

        if (!dateSearch) {
            dateSearch = new Date();
        }

        let dateString: string = dateSearch.getFullYear().toString()
                                + '-' + ('0' + (dateSearch.getMonth() + 1)).slice(-2)
                                + '-' + ('0' + dateSearch.getDate()).slice(-2)
                                + 'T' + ('0' + dateSearch.getHours()).slice(-2)
                                + ':' + ('0' + dateSearch.getMinutes()).slice(-2)
                                + ':' + ('0' + dateSearch.getSeconds()).slice(-2);

        let searchQuery: string = `validSince:[* TO "${dateString}"] AND validUntil:["${dateString}" TO *]`;

        if (showInHomePage) {
            searchQuery += ` AND showInHomePage:${showInHomePage}`;
        }

        if (showInLessonsPage) {
            searchQuery += ` AND showInLessonListPage:${showInLessonsPage}`;
        }

        return this.search({query: searchQuery});

    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article.service.ts